import { Button } from 'grommet';
import styled from 'styled-components';
const ButtonConfirm = styled(Button) `
  color: #fff;
`;
export default ButtonConfirm;
